import { getServices } from '~/db/services';

export const useFeedLoadFromNetwork = async () => {
  const feed = useFeedStore();

  const _fetchData = async (url) => {
    const { result, error } = await useApiFetch(url, {
      method: 'GET',
    });
    if (error) {
      throw error;
    } else {
      return result;
    }
  };

  try {
    const result = await _fetchData(`${URI.Feed}`);
    const feeds = result.feeds || [];
    const medias = result.medias || [];
    feed.setData(feeds, medias);

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
